export enum QueryParamType {
  String = 'string',
  Array = 'array',
  Number = 'number',
}